import { API_URL } from '../config';

export const SUPPORT_RECIPIENTS = [
  'Z.elboukhari@muntmasters.com',
  'y.elbernoussi@muntmasters.com'
];

const STORAGE_KEY = 'axoLastClientError';

const getErrorMessage = (error) => {
  if (!error) return 'Unknown client error';
  if (typeof error === 'string') return error;
  return error.message || error.reason?.message || String(error);
};

const getErrorStack = (error) => {
  if (!error || typeof error === 'string') return '';
  return error.stack || error.reason?.stack || '';
};

export const captureClientError = (error, details = {}) => {
  const payload = {
    message: getErrorMessage(error),
    stack: getErrorStack(error),
    componentStack: details.componentStack || '',
    component: details.component || '',
    source: details.source || '',
    line: details.line || null,
    column: details.column || null,
    page: details.page || window.location.pathname,
    url: window.location.href,
    userAgent: window.navigator.userAgent,
    reportedAt: new Date().toISOString()
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // Session storage may be blocked; the caller can still use the returned payload.
  }

  return payload;
};

export const getCapturedClientError = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const reportClientErrorToTeams = async (errorDetails = {}) => {
  const token = localStorage.getItem('token');
  const payload = {
    recipients: SUPPORT_RECIPIENTS,
    channel: 'teams',
    source: 'axo-people-front',
    error: {
      ...errorDetails,
      page: errorDetails.page || window.location.pathname,
      url: errorDetails.url || window.location.href,
      reportedAt: errorDetails.reportedAt || new Date().toISOString()
    }
  };

  const response = await fetch(`${API_URL}/support/error-report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(payload),
    keepalive: true
  });

  if (!response.ok) {
    throw new Error(`Error report failed with status ${response.status}`);
  }

  return response;
};
